import { API_BASE_URL, HEADERS_WITH_TOKEN } from "./BaseUrl";

export const getWebPages = () =>
  fetch(
    `${API_BASE_URL}/web-pages`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN
    }
  )
  .then(res => res.json())


export const saveWebPage = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/web-pages`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editWebPage = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/web-pages/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const deleteWebPage = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/web-pages/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN
    }
  )
  return await res.json()
}

export const editWebPageCodes = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/web-pages/${id}/codes`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const editWebPageSocialLinks = async (data) => {
  const { id, params } = data
  params.forEach(el => {
    delete el['id']
  })
  const res = await fetch(
    `${API_BASE_URL}/web-pages/${id}/social-links`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN,
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}